<template>
  <div class="time-span-input">
    <NumericTextBox
      class="time-input"
      :min="0"
      :max="23"
      format="n0"
      v-model="hours"
      :spinners="false"
      :step="1"
      :inputSuffix="'suffix'"
      inputType="number"
      :disabled="disabled"
      :required="required"
    >
      <template v-slot:suffix>
        <span>HH</span>
      </template>
    </NumericTextBox>
    :
    <NumericTextBox
      class="time-input"
      :min="0"
      :max="59"
      format="n0"
      v-model="minutes"
      :spinners="false"
      :step="1"
      :inputSuffix="'suffix'"
      inputType="number"
      :disabled="disabled"
      :required="required"
    >
      <template v-slot:suffix>
        <span>MM</span>
      </template>
    </NumericTextBox>
  </div>
</template>

<script setup lang="ts">
import { NumericTextBox } from "@progress/kendo-vue-inputs";
import { computed } from "vue";

const modelValue = defineModel<string>({ default: "" });

defineProps<{
  disabled?: boolean;
  required?: boolean;
}>();

const parseTimeValue = () => {
  if (!modelValue.value) return { hours: null, minutes: null };
  const parts = modelValue.value.split(":");
  return {
    hours: parts.length > 0 ? Number(parts[0]) || 0 : 0,
    minutes: parts.length > 1 ? Number(parts[1]) || 0 : 0,
  };
};

const hours = computed({
  get: () => parseTimeValue().hours,
  set: (val: number | null) => {
    const parsed = parseTimeValue();
    const mins = parsed.minutes ?? 0;
    modelValue.value = `${String(val ?? 0).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
  },
});

const minutes = computed({
  get: () => parseTimeValue().minutes,
  set: (val: number | null) => {
    const parsed = parseTimeValue();
    const hrs = parsed.hours ?? 0;
    modelValue.value = `${String(hrs).padStart(2, "0")}:${String(val ?? 0).padStart(2, "0")}`;
  },
});
</script>

<style lang="scss">
.time-span-input {
  display: flex;
  align-items: center;
  gap: 4px;

  .time-input {
    width: 80px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  .k-input-suffix {
    font-weight: bold;
    font-size: 12px;
    margin-right: 4px;
  }

  .time-input {
    input {
      padding: 4px !important;
    }
  }
}
</style>
